$(function() {

    $(".contacts__address-item").click(function(e) {
        e.preventDefault();
        $(".contacts__address-item").removeClass('contacts__address-item-act');
        $(this).addClass('contacts__address-item-act');
    })

    $(".js-toggler").click(function(e) {
        $(this).toggleClass('open');
        $('.header').toggleClass('open-bl');
        $('body').toggleClass('overfl');
    })

    $(".js-tels-mob").click(function(e) {
        $(this).parent().addClass('open');
    })

    $(".js-search-mob").click(function(e) {
        $(this).parent().addClass('open');
    })


    $('.header__menu li.dropdown').on("click", function(e){
        $(this).toggleClass('active');
    });

    $('.header__menu ul>li.submenu a').on("click", function(e){
        $(this).parent().toggleClass('active');
    });

    $('.map-site__list ul li.drop').on("click", function(e){
        $(this).toggleClass('open');
    });

    $('.nav-link').on("click", function(e){
        $('.page__holder-tw').removeClass('open');
    });
    $('.nav-link[aria-controls="tab-r"]').on("click", function(e){
        $('.page__holder-tw').addClass('open');
    });





    $(".phone-mask").mask("+7 999 9999999",{ "clearIncomplete": false });

    $(document).on('click', '.datepicker', function () {
        var me = $(".datepicker");
        me.datepicker({
            showOn: 'focus',
            altFormat: "dd.mm.yy",
            dateFormat: "dd.mm.yy",
        }).focus();
    }).on('focus', '.datepicker', function () {
        var me = $(".datepicker");
        me.mask('99.99.9999');
    });




    $('.js-banner-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        fade: true,
        cssEase: 'linear',
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000
    });
    $('.js-ad-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.js-ad-slider-tw').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.js-specialists-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.js-reviews-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
    });
    $('.js-news-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.js-news-slider-tw').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.js-license-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 460,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.js-services-page-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        fade: true,
        cssEase: 'linear',
        arrows: true
    });
    $('.js-doctor-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        fade: true,
        cssEase: 'linear',
        arrows: true
    });
    $('.js-price-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.about__history-slider-for').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.about__history-slider-nav'
    });
    $('.about__history-slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.about__history-slider-for',
        dots: false,
        focusOnSelect: true,
        variableWidth: true
    });
    $('.js-license-slider-tw').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 460,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.modal-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.modal-slider-nav'
    });
    $('.modal-slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.modal-slider-for',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        variableWidth: true
    });


    $('.modal').on('shown.bs.modal', function (e) {
        $('.modal-slider-for,.modal-slider-nav').slick("setPosition", 0);
    })



    //Переменная для включения/отключения индикатора загрузки
    var spinner = $('.ymap-container').children('.loader');
//Переменная для определения была ли хоть раз загружена Яндекс.Карта (чтобы избежать повторной загрузки при наведении)
    var check_if_load = false;
//Необходимые переменные для того, чтобы задать координаты на Яндекс.Карте
    var myMapTemp, myPlacemarkWithContent_1, myPlacemarkWithContent_2;

//Функция создания карты сайта и затем вставки ее в блок с идентификатором &#34;map-yandex&#34;
    function init () {
        var myMapTemp = new ymaps.Map("map-yandex", {
            center: [46.313774026125266, 39.38382968447013],
            zoom: 15,
        });
        var myPlacemarkWithContent_1 = new ymaps.Placemark([46.313532, 39.383858], {
            hintContent: '',
        }, {
            iconLayout: 'default#imageWithContent',
            iconImageHref: 'assets/images/svg/pinmap1.svg',
            iconImageSize: [50, 50],
            iconImageOffset: [-25, -50],
            iconContentOffset: [15, 15]
        });

        var myPlacemarkWithContent_2 = new ymaps.Placemark([46.311260, 39.377120], {
            hintContent: '',
        }, {
            iconLayout: 'default#imageWithContent',
            iconImageHref: 'assets/images/svg/pinmap1.svg',
            iconImageSize: [50, 50],
            iconImageOffset: [-25, -50],
            iconContentOffset: [15, 15]
        });
        myMapTemp.geoObjects.add(myPlacemarkWithContent_1).add(myPlacemarkWithContent_2); // помещаем флажок на карту

        // Получаем первый экземпляр коллекции слоев, потом первый слой коллекции
        var layer = myMapTemp.layers.get(0).get(0);

        // Решение по callback-у для определения полной загрузки карты
        waitForTilesLoad(layer).then(function() {
            // Скрываем индикатор загрузки после полной загрузки карты
            spinner.removeClass('is-active');
        });
    }

// Функция для определения полной загрузки карты (на самом деле проверяется загрузка тайлов)
    function waitForTilesLoad(layer) {
        return new ymaps.vow.Promise(function (resolve, reject) {
            var tc = getTileContainer(layer), readyAll = true;
            tc.tiles.each(function (tile, number) {
                if (!tile.isReady()) {
                    readyAll = false;
                }
            });
            if (readyAll) {
                resolve();
            } else {
                tc.events.once("ready", function() {
                    resolve();
                });
            }
        });
    }

    function getTileContainer(layer) {
        for (var k in layer) {
            if (layer.hasOwnProperty(k)) {
                if (
                    layer[k] instanceof ymaps.layer.tileContainer.CanvasContainer
                    || layer[k] instanceof ymaps.layer.tileContainer.DomContainer
                ) {
                    return layer[k];
                }
            }
        }
        return null;
    }

// Функция загрузки API Яндекс.Карт по требованию (в нашем случае при наведении)
    function loadScript(url, callback){
        var script = document.createElement("script");

        if (script.readyState){  // IE
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {  // Другие браузеры
            script.onload = function(){
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    }

// Основная функция, которая проверяет когда мы навели на блок с классом &#34;ymap-container&#34;
    var ymap = function() {
        $('.ymap-container').mouseenter(function(){
                if (!check_if_load) { // проверяем первый ли раз загружается Яндекс.Карта, если да, то загружаем

                    // Чтобы не было повторной загрузки карты, мы изменяем значение переменной
                    check_if_load = true;

                    // Показываем индикатор загрузки до тех пор, пока карта не загрузится
                    spinner.addClass('is-active');

                    // Загружаем API Яндекс.Карт
                    loadScript("https://api-maps.yandex.ru/2.1/?lang=ru_RU&amp;loadByRequire=1", function(){
                        // Как только API Яндекс.Карт загрузились, сразу формируем карту и помещаем в блок с идентификатором &#34;map-yandex&#34;
                        ymaps.load(init);
                    });
                }
            }
        );
    }

    $(function() {

        //Запускаем основную функцию
        ymap();

    });




});

